import Request from "../model/Request";
import Response from "../model/Response";
import {RestClient} from "../util/RestClient";
import {Config} from "../util/Config";
import PagedResponse from "../entities/PagedResponse";
import Pagination from "../entities/Pagination";
import TransactionStatus from "../entities/TransactionStatus";
import AgencyBalanceTransaction from "../entities/AgencyBalanceTransaction";

export module AgencyBalanceTransactionService {
    export async function get(
        agencyId: string,
        page: number = 1,
        pageSize: number = 15,
        from?: number,
        to?: number,
        status?: TransactionStatus,
    ): Promise<Response<PagedResponse<AgencyBalanceTransaction>>> {
        const url = Config.get("GET_AGENCY_BALANCE_TRANSACTION_URL", {page, pageSize, id: agencyId, from, to, status});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const transactionData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (transactionData && paginationData) {
                const data = transactionData.map((t: any) =>
                    new AgencyBalanceTransaction(
                        t.id,
                        t.agencyId,
                        t.amount,
                        t.createdAt,
                        t.createdBy,
                        t.status,
                        t.remainingBalanceAfter,
                        t.paymentMethod,
                        t.agencyBillingClosureId,
                        t.comment,
                    ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<AgencyBalanceTransaction>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<AgencyBalanceTransaction>>(false, undefined, response.error, response.status);
    }

}